const layout = {
	seo: {
		description: "Work where you want, when you want & start earning.",
	},
};

export default layout;
